/**
 * TradingView-style left drawing toolbar.
 * Tools that map to existing features (hline, fib, cursor) are wired;
 * others are present for layout fidelity and future use.
 */
const TOOLS = [
  { id: 'cursor', icon: 'bi-cursor', title: 'Crosshair / cursor' },
  { id: 'trend', icon: 'bi-slash-lg', title: 'Trend line' },
  { id: 'hline', icon: 'bi-dash-lg', title: 'Horizontal line' },
  { id: 'ray', icon: 'bi-arrow-right', title: 'Ray' },
  { id: 'rect', icon: 'bi-square', title: 'Rectangle' },
  { id: 'fib', icon: 'bi-distribute-vertical', title: 'Fibonacci' },
  { id: 'text', icon: 'bi-fonts', title: 'Text' },
  { id: 'measure', icon: 'bi-rulers', title: 'Measure' },
  { id: 'zoom', icon: 'bi-zoom-in', title: 'Zoom' },
  { id: 'magnet', icon: 'bi-magnet', title: 'Magnet mode' },
  { id: 'lock', icon: 'bi-lock', title: 'Lock drawings' },
  { id: 'trash', icon: 'bi-trash', title: 'Remove drawings' },
];

export default function TvLeftToolbar({
  activeTool = 'cursor',
  onToolChange,
  showFib = true,
  onToggleFib,
}) {
  const handle = (id) => {
    if (id === 'fib') {
      onToggleFib?.();
      onToolChange?.(id);
      return;
    }
    onToolChange?.(id);
  };

  return (
    <aside className="tv-left-toolbar" aria-label="Drawing tools">
      {TOOLS.map((t) => {
        const isActive = t.id === activeTool || (t.id === 'fib' && showFib && activeTool === 'fib');
        return (
          <button
            key={t.id}
            type="button"
            className={`tv-tool-btn${isActive ? ' active' : ''}${t.id === 'fib' && showFib ? ' on' : ''}`}
            title={t.title}
            onClick={() => handle(t.id)}
          >
            <i className={`bi ${t.icon}`} />
          </button>
        );
      })}
    </aside>
  );
}
